module.exports = __webpack_public_path__ + "media/assets/illustrations/unsupported-browser-1d78c585564bc0c77c159a8429a57239.png";